import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Image from '../../../../components/ContentfulImage';
import Placeholder from '../../../../components/Placeholder';

import {
  Container,
  ItemList,
  ImageCover,
  SectionColumnContainer,
  SectionRowContainer,
  SectionTextTitle,
  SectionTextTitleName,
  SectionTextTitleDesc,
  LabelIcon,
  PromotionLabel,
  LabelText,
} from './SublimicHomeCareListSection.style';

const SublimicHomeCareListSection = ({ locale, labelText, item, i, screenSize, isHairAndScalp }) => {
  const { slug, title, name, description, image, color, labelCopyColor, promotionText } = item;

  const ImageP = () => (
    <ImageCover>
      {(!!image && (
        <Image
          src={image}
          options={{
            w: ['118px', '240px'],
          }}
        />
      )) || <Placeholder w="159px" h="159px" />}
    </ImageCover>
  );

  const SectionTextTitleP = () => (
    <div>
      {promotionText && <PromotionLabel>{promotionText}</PromotionLabel>}
      <SectionTextTitle>{title || <Placeholder w="212px" h="26px" />}</SectionTextTitle>
      <SectionTextTitleName>{name || <Placeholder w="170px" h="20px" />}</SectionTextTitleName>
    </div>
  );

  const SectionTextTitleDescP = () => (
    <SectionTextTitleDesc>
      {description.map(item => (
        <li key={item}>
          <span>{item}</span>
        </li>
      )) || <Placeholder w="436px" h="48px" />}
    </SectionTextTitleDesc>
  );

  return (
    <Container>
      <Link
        key={i}
        to={`/${locale}/salon-consultation/sublimic/homecare/${slug}`}
        href={`/${locale}/salon-consultation/sublimic/homecare/${slug}`}
      >
        <ItemList key={i}>
          <LabelIcon color={color} isHairAndScalp={isHairAndScalp}>
            {labelText ? (
              <LabelText color={labelCopyColor} dangerouslySetInnerHTML={{ __html: labelText }} />
            ) : (
              <Placeholder w="98px" h="27px" />
            )}
          </LabelIcon>
          {screenSize === 0 ? (
            <React.Fragment>
              <SectionRowContainer>
                <ImageP />
                <SectionTextTitleP />
              </SectionRowContainer>
              <SectionTextTitleDescP />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ImageP />
              <SectionColumnContainer hasPromotionText={promotionText}>
                <SectionTextTitleP />
                <SectionTextTitleDescP />
              </SectionColumnContainer>
            </React.Fragment>
          )}
        </ItemList>
      </Link>
    </Container>
  );
};

SublimicHomeCareListSection.defaultProps = {
  locale: undefined,
  labelText: undefined,
  item: {
    slug: undefined,
    title: undefined,
    name: undefined,
    description: undefined,
    image: undefined,
    color: undefined,
  },
  i: undefined,
  isHairAndScalp: false,
};

SublimicHomeCareListSection.propTypes = {
  locale: PropTypes.string,
  labelText: PropTypes.string,
  item: PropTypes.shape({}),
  i: PropTypes.number,
  screenSize: PropTypes.number.isRequired,
  isHairAndScalp: PropTypes.bool,
};
const mapState = state => ({
  locale: state.locale,
  screenSize: state.screenSize,
});

export default connect(mapState)(SublimicHomeCareListSection);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicHomeCareList/SublimicHomeCareListSection/SublimicHomeCareListSection.js